module.exports = __webpack_public_path__ + "img/carbon-radio.87353ad0.svg";